import { useEffect, useState } from "react"
import { apiFetch } from "../../lib/api"
import { useEmpresa } from "../../app/context/EmpresaContext"

type Dfe = { id: string; chave: string; nsu: string; manifestacao: string | null }

export const DfePage = () => {
  const { empresaId } = useEmpresa()
  const [items, setItems] = useState<Dfe[]>([])
  const [message, setMessage] = useState("")

  const load = async () => {
    if (!empresaId) return
    setItems(await apiFetch<Dfe[]>(`/v1/empresas/${empresaId}/dfe`))
  }

  useEffect(() => {
    load()
  }, [empresaId])

  const handleSync = async () => {
    if (!empresaId) return
    await apiFetch(`/v1/empresas/${empresaId}/dfe/sincronizar`, { method: "POST" })
    setMessage("Sincronização enfileirada.")
    setTimeout(load, 2000)
  }

  const handleManifest = async (chave: string) => {
    if (!empresaId) return
    await apiFetch(`/v1/empresas/${empresaId}/dfe/chave/${chave}/manifestar`, {
      method: "POST",
      body: JSON.stringify({ tipo: "210210" }),
    })
    await load()
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-2xl font-bold text-slate-900">DFe recebidas</h1>
        <button type="button" onClick={handleSync} className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white">
          Sincronizar NSU
        </button>
      </div>
      {message && <p className="text-sm text-slate-600">{message}</p>}
      <ul className="rounded-xl border border-slate-200 bg-white divide-y">
        {items.map((d) => (
          <li key={d.id} className="flex flex-wrap items-center justify-between gap-2 px-5 py-3 text-sm">
            <div>
              <p className="font-mono text-xs">{d.chave}</p>
              <p className="text-slate-500">NSU {d.nsu} · {d.manifestacao ?? "sem manifestação"}</p>
            </div>
            <button type="button" onClick={() => handleManifest(d.chave)} className="text-brand-600 hover:underline">
              Ciência
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
